import { IClientContextProps, IClient } from "./ClientContext";
import { appsettings } from "../../app.config";
import { useEffect, useState } from "react";

declare global {
  interface Window {
    appclient: any;
  }
}

const getDefaultClient = (): IClient => {
  const defaultClientName = appsettings.clients["default"];
  return appsettings.clients[defaultClientName] as IClient;
};

const resolveClient = (hostname: string): IClient => {
  if (hostname === "localhost") {
    return getDefaultClient();
  }

  for (const key in appsettings.clients) {
    const item = appsettings.clients[key] as IClient;
    if (key === hostname) {
      return item;
    }
  }

  return getDefaultClient();
};

const applyClient = (client: IClient) => {
  document.title = client.title;

  const favicon =
    document.querySelector<HTMLLinkElement>("link[rel~='icon']") ??
    document.createElement("link");
  favicon.rel = "icon";
  favicon.href = client.logo || "/favicon.ico";
  if (!favicon.parentNode) {
    document.head.appendChild(favicon);
  }

  try {
    if (window.top?.document) {
      window.top.document.title = client.title;
    }
  } catch (error) {
    console.warn("Error reading appclient from sessionStorage", error);
  }

  window.sessionStorage.setItem("appclient", JSON.stringify(client));
  window.appclient = client;
};

const useProvideClient: () => IClientContextProps = () => {
  const [client] = useState<IClient>(() =>
    resolveClient(window.location.hostname)
  );

  useEffect(() => {
    applyClient(client);
  }, [client]);

  return { client };
};

export default useProvideClient;